import React from "react";
// import MetaTags from "react-meta-tags";

// Components
import { PageHeading } from "../components/PageHeading";
import { ServicePageWrapper } from "styling/ServicePagesStyling";
import { LinkToPage } from "../components/LinkToPage";

export const Lectures = () => {
  return (
    <>
      {/* <MetaTags>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>We Exist - Föreläsningar</title>
        <meta
          name="description"
          content="Vi föreläser om jämställdhet i arbetslivet och hur det kan hjälpa ert företag att bli mer lönsamt och 
          trivsamt."
        />
        <meta property="og:title" content="We Exist - Föreläsningar" />
        <meta
          property="og:description"
          content="Vi föreläser om jämställdhet i arbetslivet och hur det kan hjälpa ert företag att bli mer lönsamt och 
          trivsamt."
        />
        <meta property="og:image" content="service-images/rekrytering.jpg" />
      </MetaTags> */}

      <PageHeading title="Föreläsningar" />
      <ServicePageWrapper>
        <img src="./service-images/forelasning.jpg" alt="föreläsning" />
        <p>
          Jämställdhet är inte enbart en fråga för kvinnor, vi vill därför nå ut
          till alla era medarbetare för att prata mer om vikten och innebörden
          av att få in jämställdhetsarbetet på en daglig basis och att det är
          något alla på företaget aktivt behöver jobba med. Vi går igenom
          forskning och data på hur jämställdheten gynnar er som bolag och
          presenterar sedan konkreta tips och verktyg på hur ni kan nå dit. Vi
          anpassar självklart föreläsningen utifrån era behov och önskemål.
          Kontakta oss för att få en skräddarsydd offert!
        </p>

        <LinkToPage location="/for-foretag" text="Kontakta We Exist" />
      </ServicePageWrapper>
    </>
  );
};
